

import { settings } from './settings'

let strings = {}

const loadTranslations = async (market) => {
	const contentful = entry => fetch(`${settings.contentfulApi}/entry/${entry}/${market}`)
	const [localizations, description, confirmationDescription, importantInformationDescription, termsAndConditionText, gdprText ] = await Promise.all([
		contentful('8w4GKT7pbBc1liRoCUZ4A').then(res => res.json()),
		contentful('4rsTQnMwBmkWBiCn9jPDQT').then(res => res.text()),
        contentful('0jTe1wj6OjYb3uv2fUES9').then(res => res.text()),
		contentful('4X8jOies6LvlkUnRXEeiJf').then(res => res.text()),
		contentful('34jrS73uBAhnOdwtueVUjR').then(res => res.text()),
		contentful('6mxyIIgOwJmrxkS8w5pNFM').then(res => res.text())
	])
	strings = { ...localizations, description, confirmationDescription, importantInformationDescription, termsAndConditionText, gdprText }
}

export { loadTranslations, strings }